/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type ChatMessageSendingJobStatus =
  | 'ChatMessageSendingJobStatusCompleted'
  | 'ChatMessageSendingJobStatusFailed'
  | 'ChatMessageSendingJobStatusPending'
  | 'ChatMessageSendingJobStatusRunning';

export type UpdateScheduledTimeOfChatMessageSendingJobInput = {
  guid: string | number;
  /**
   * 更新する送信日時
   * nullに更新すると即時送信されるので注意！
   */
  scheduledAt?: TimeString | null | undefined;
};

export type ChatMessageSendingJobDetailPageScheduledTimeFragment = { chatMessageSendingJob: { status: Types.ChatMessageSendingJobStatus, guid: string, scheduledAt: TimeString | null } | null };

export type UpdateScheduledTimeOfChatMessageSendingJobMutationVariables = Exact<{
  input: Types.UpdateScheduledTimeOfChatMessageSendingJobInput;
}>;


export type UpdateScheduledTimeOfChatMessageSendingJobMutation = { updateScheduledTimeOfChatMessageSendingJob:
    | { reason: string }
    | { jobGuid: string | null }
   };

export const ChatMessageSendingJobDetailPageScheduledTimeFragmentDoc = gql`
    fragment ChatMessageSendingJobDetailPageScheduledTime on Query {
  chatMessageSendingJob(guid: $guid) {
    status
    guid
    scheduledAt
  }
}
    `;
export const UpdateScheduledTimeOfChatMessageSendingJobDocument = gql`
    mutation updateScheduledTimeOfChatMessageSendingJob($input: UpdateScheduledTimeOfChatMessageSendingJobInput!) {
  updateScheduledTimeOfChatMessageSendingJob(input: $input) {
    ... on UpdateScheduledTimeOfChatMessageSendingJobSuccessPayload {
      jobGuid
    }
    ... on UpdateScheduledTimeOfChatMessageSendingJobErrorPayload {
      reason
    }
  }
}
    `;

/**
 * __useUpdateScheduledTimeOfChatMessageSendingJobMutation__
 *
 * To run a mutation, you first call `useUpdateScheduledTimeOfChatMessageSendingJobMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduledTimeOfChatMessageSendingJobMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateScheduledTimeOfChatMessageSendingJobMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScheduledTimeOfChatMessageSendingJobMutation(options: VueApolloComposable.UseMutationOptions<UpdateScheduledTimeOfChatMessageSendingJobMutation, UpdateScheduledTimeOfChatMessageSendingJobMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateScheduledTimeOfChatMessageSendingJobMutation, UpdateScheduledTimeOfChatMessageSendingJobMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateScheduledTimeOfChatMessageSendingJobMutation, UpdateScheduledTimeOfChatMessageSendingJobMutationVariables>(UpdateScheduledTimeOfChatMessageSendingJobDocument, options);
}
export type UpdateScheduledTimeOfChatMessageSendingJobMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateScheduledTimeOfChatMessageSendingJobMutation, UpdateScheduledTimeOfChatMessageSendingJobMutationVariables>;